import { render, staticRenderFns } from "./MirrorDataTabs.vue?vue&type=template&id=ea422692"
import script from "./MirrorDataTabs.vue?vue&type=script&lang=js"
export * from "./MirrorDataTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports